import { Entity } from '../../services/restService';

export enum TaskStatus {
    NotStarted = 'notstarted',
    InProgress = 'inprogress',
    Completed = 'completed',
    Cancelled = 'cancelled',
    OnHold = 'onhold',
}

export interface Task extends Entity {
    clientId: string;
    sessionId?: string;
    sessionName?: string;
    content: string;
    category?: string;
    actor?: string;
    creator?: string;
    status: TaskStatus;
    dueDate?: Date;
    attachments?: number;
    createdDate?: Date;
    updatedDate?: Date;
}
